<template>
  <v-app id="inspire">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar class="koiote_logo" color="white">
                <v-toolbar-title>
                  <v-img alt="logo koiote" width="120" src="@/assets/koiote-logotipo.png" transition="scale-transition" />
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text class="text-center">
                <span class="display-1 font-weight-bold">Iniciar Sesión</span>
                <v-form class="mt-6">
                  <v-text-field prepend-inner-icon="mdi-account" name="username" label="Usuario" type="text"
                    :rules="[(v) => !!v || 'Rellene el usuario']" v-model="userInfo.username"></v-text-field>
                  <v-text-field prepend-inner-icon="mdi-lock" id="password" name="psw" label="Contraseña"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword" v-model="userInfo.password"
                    :rules="[(v) => !!v || 'Rellene la contraseña']"></v-text-field>
                </v-form>
                <!-- {{ userInfo }} -->
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn elevation="4" class="mb-2 mr-3" color="#006699" outlined @click="logInApp">Entrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-dialog v-model="dialog" :overlay="false" max-width="500px" transition="dialog-transition">
      <v-alert type="error">
        <v-row align="center" no-gutters>
          <v-col class="grow">
            {{ error_text }}
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col class="shrink">
            <v-btn outlined @click="dialog = false"> Volver a intentar </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
    <Keypress key-event="keydown" :key-code="13" @success="logInApp" />
  </v-app>
</template>
<script>
const BACK_URL = process.env.VUE_APP_BACKEND_URL;
const BACK_PORT = process.env.VUE_APP_BACKEND_PORT;
import axios from "axios"
export default {
  data() {
    return {
      userInfo: {
        username: "",
        password: "",
      },
      showPassword: false,
      dialog: false,
      error_text: "",
    };
  },
  components: {
    Keypress: () => import("vue-keypress"),
  },
  methods: {
    async logInApp() {
      try {
        const res = await axios.post(
          `${BACK_URL}:${BACK_PORT}/api/auth/login/`,
          this.userInfo
        );
        if (res.data && res.data.token) {
          localStorage.setItem("token", res.data.token);
          // Ahora, verificamos si el token es válido
          const tokenCheck = await axios.get(`${BACK_URL}:${BACK_PORT}/api/auth/verify-token/`, {
            headers: {
              'Authorization': `Bearer ${res.data.token}`
            }
          });

          if (tokenCheck.data.isValid) {
            this.$router.push({ name: "home" });
          } else {
            // Manejo del token inválido
            this.error_text = "Token no válido. Intente de nuevo.";
            this.dialog = true;
            localStorage.removeItem("token");
          }
        } else {
          // Manejo de error en el inicio de sesión
          this.error_text = "Usuario o contraseña incorrectos";
          this.dialog = true;
        }
      } catch (error) {
        // Manejo de errores generales
        console.error("Error en el inicio de sesión:", error);
        this.error_text = "Hubo un problema al intentar iniciar sesión. Intente de nuevo.";
        this.dialog = true;
      }
    }
  },
};
</script>
<style></style>
